import React from 'react';
import OtherServicesForm from '../OtherServicesForm';
import '../OtherServicesForm.css';

const OtherServicesSalesPage = ({ onNavigate }) => {
  return (
    <div className="page-bleed">
      <OtherServicesForm onNavigate={onNavigate} />
    </div>
  );
};

export default OtherServicesSalesPage;
